import React from "react";

const ArrowPath = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-arrow-path"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-arrow-path"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m18,18c0,3.309-2.691,6-6,6s-6-2.691-6-6c0-.403.04-.807.119-1.198.11-.541.64-.893,1.179-.782.541.11.892.638.782,1.179-.054.262-.08.531-.08.802,0,2.206,1.794,4,4,4s4-1.794,4-4-1.794-4-4-4h-1l1.707,1.707c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.75-2.75c-.78-.779-.78-2.048,0-2.828l2.75-2.75c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-1.793,1.793h1.086c3.309,0,6,2.691,6,6Zm-.026-12.858c-.332-.066-.603-.273-.742-.569C15.68,1.301,12.089-.527,8.497.134,5.225.734,2.66,3.346,2.113,6.635c-.162.971-.15,1.943.033,2.89.06.309-.073.653-.346.901-1.145,1.041-1.801,2.524-1.801,4.07,0,2.592,1.805,4.766,4.222,5.344-.14-.592-.222-1.206-.222-1.841,0-.536.054-1.073.159-1.594.16-.788.615-1.464,1.282-1.906.225-.149.469-.256.72-.337-.122-.387-.204-.788-.204-1.206,0-1.069.416-2.074,1.171-2.829l2.75-2.75c1.17-1.17,3.072-1.17,4.242,0,.849.848,1.073,2.081.69,3.141,3.026,1.142,5.188,4.059,5.188,7.48,0,.399-.039.788-.096,1.171,2.427-1.243,4.096-3.765,4.096-6.674,0-3.565-2.534-6.658-6.026-7.354Z" />
    </svg>
  );
};

export default ArrowPath;
